import React from 'react';

interface CardOptionProps {
  option: string;
  optionId?: string | number;
  selected: boolean;
  onClick: () => void;
  type: 'radio' | 'checkbox';
  primaryColor?: string;
}

export const CardOption: React.FC<CardOptionProps> = ({
  option,
  optionId,
  selected,
  onClick,
  type,
  primaryColor = '#3B82F6',
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full p-3 border rounded-lg text-left flex items-start gap-3 transition-colors ${
        selected
          ? 'border-2'
          : 'border-gray-300 hover:border-gray-400'
      }`}
      style={{
        backgroundColor: '#ffffff',
        borderColor: selected ? primaryColor : undefined,
      }}
    >
      <div className="mt-0.5">
        {type === 'radio' ? (
          <div
            className={`w-4 h-4 rounded-full border-2 ${
              selected
                ? 'border-current'
                : 'border-gray-400'
            } flex items-center justify-center`}
            style={selected ? { borderColor: primaryColor, backgroundColor: primaryColor } : undefined}
          >
            {selected && <div className="w-1.5 h-1.5 bg-white rounded-full"></div>}
          </div>
        ) : (
          <div
            className={`w-4 h-4 rounded border-2 ${
              selected
                ? 'border-current'
                : 'border-gray-400'
            } flex items-center justify-center`}
            style={selected ? { borderColor: primaryColor, backgroundColor: primaryColor } : undefined}
          >
            {selected && (
              <svg
                width="10"
                height="8"
                viewBox="0 0 10 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9 1L3.5 6.5L1 4"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>
        )}
      </div>
      <span className="text-gray-700">{option}</span>
    </button>
  );
};